export var UpdateTeamErrorCodes;
(function (UpdateTeamErrorCodes) {
    UpdateTeamErrorCodes["DUPLICATE_ENTITY"] = "DUPLICATE_ENTITY";
})(UpdateTeamErrorCodes || (UpdateTeamErrorCodes = {}));
